// extracted by mini-css-extract-plugin
export default {"imageWrapper":"VI-z","twoColumnImage":"WI-z"};